import {
  SET_GENERAL_INFO,
  SET_BUSINESS_DETAILS,
  SET_VALUATION_INFO,
  SET_DISCLOSURE
} from "./mutations";
import { store } from "../../index";

export const updateGeneralInfo = (name, value) => (dispatch) => {
  const { generalInfo } = store.getState().generalData;

  generalInfo[name] = value;

  dispatch({
    type: SET_GENERAL_INFO,
    payload: { ...generalInfo }
  });
};

export const updateBusinessDetails = (name, value) => (dispatch) => {
  const { businessDetails } = store.getState().generalData;

  businessDetails[name] = value;

  dispatch({
    type: SET_BUSINESS_DETAILS,
    payload: { ...businessDetails }
  });
}

export const updateValuationInfo = (name, value) => (dispatch) => {
  const { valuationInfo } = store.getState().generalData;

  valuationInfo[name] = value;

  dispatch({
    type: SET_VALUATION_INFO,
    payload: { ...valuationInfo }
  });
}

export const updateDisclosure = (name, value) => (dispatch) => {
  const { disclosure } = store.getState().generalData;

  disclosure[name] = value;

  dispatch({
    type: SET_DISCLOSURE,
    payload: { ...disclosure }
  });
}